<template>
  <div>
    <div v-if="children && !repeat">
      <select-all-option v-model="prisonInfo" :group-value="children" :data="dataInfo"/>
      <el-option-group
        v-for="p in dataInfo"
        :label="p[groupLabel]"
        :key="p[groupKey]">
        <el-option :label="r[label]" :key="r[optionKey]" :value="r" v-for="r in p[children]"/>
      </el-option-group>
    </div>
    <div v-else-if="repeat">
      <select-all-option v-model="prisonInfo" :data="dataInfo"/>
      <el-option :label="r[label]" :key="r[optionKey]" :value="valueKey ? r[valueKey] : r" v-for="r in dataInfo"/>
    </div>
    <div v-else>
      <select-all-option v-model="prisonInfo" :data="value"/>
      <el-option :label="r[label]" :key="r[optionKey]" :value="valueKey ? r[valueKey] : r" v-for="r in value"/>
    </div>
  </div>
</template>

<script>
import selectAllOption from '@/components/selectAllOption'

export default {
  name: "index",
  components: {selectAllOption},
  props : {
    value: {
      default: undefined,
      type: Array
    },
    valueKey: {
      default: undefined,
      type: String
    },
    optionKey: {
      default: undefined,
      type: String
    },
    label: {
      default: undefined,
      type: String
    },
    groupKey: {
      default: undefined,
      type: String
    },
    groupLabel: {
      default: undefined,
      type: String
    },
    children: {
      default: undefined,
      type: String
    },
    repeat: {
      default: false,
      type: Boolean
    },
    parent: {
      default: undefined,
      type: Array
    },
    parentChildren: {
      default: undefined,
      type: String
    },
    prison: {
      default: undefined,
      type: Array
    }
  },
  watch: {
    value(val){
      if (this.repeat){
        let val2 = []
        let optionKey = this.optionKey
        let children = this.children
        if (children){
          let val3 = []
          val.forEach((item) => val3 = val3.concat(item[children]))
          val3.forEach((item) => {
            val2[item[optionKey]] = item
          })
        }else {
          val.forEach((item) => {
            val2[item[optionKey]] = item
          })
        }
        this.dataInfo = Object.values(val2)
      }else {
        this.dataInfo = val
      }
    },
    parent(val,old){
      let parentChildren = this.parentChildren
      let optionKey = this.optionKey
      let prison = this.prison
      if (val.length == 0 && !parentChildren){
        this.$emit("update:prison",[])
      } else if (old.length > val.length && val && parentChildren && prison && prison.length > 0){
        if (val.length == 0)
          this.$emit("update:prison",[])
        else {
          let val2 = []
          val.forEach((item) => {
            val2 = val2.concat(item[parentChildren])
          })
          let val3 = []
          val2.forEach((item) => val3[item[optionKey]] = item)
          val3 = Object.values(val3)
          let filter = prison.filter(p => val3.some(v => v[optionKey] == p[optionKey]))
          this.$emit("update:prison",filter)
        }
      }
    },
    prison(val){
      if (val)
         this.prisonInfo = val
    },
    prisonInfo(val){
      this.$emit("update:prison",val)
    }
  },
  data(){
    return {
      dataInfo : [],
      prisonInfo: []
    }
  }
}
</script>

<style scoped>

</style>
